const Loan = [
	'Crédit immobillier',
	'Autre crédit'
]

export default Loan



// WEBPACK FOOTER //
// ./src/common/components/MyPatrimonialLandscape/data/Loans.js